import {LoadingBar} from '@/components/LoadingBar';
import {AnalysisItem, BasicAnalysisResult} from '@/map/@types';
import {ColumnFlexBox} from '@/styled-components';
import {palette} from '@/styles';
import {HouseMarkers} from '../../../MarkerCluster/HouseMarkers';
import {ErrorBox} from '../ErrorBox';
import {NoData} from '../NoData';
import {ReportContainer} from '../StyledComponents';
import {Household} from './Household';
import {OfficeWorker} from './OfficeWorker';
import {ResidentPopulation} from './Resident';

interface IProps {
  map?: naver.maps.Map;
  item: AnalysisItem;
  data?: BasicAnalysisResult;
  isPending?: boolean;
  error?: string;
}

export const PopulationReport = ({map, isPending, error, ...props}: IProps) => {
  if (error?.length) {
    return (
      <ReportContainer>
        <ErrorBox />
      </ReportContainer>
    );
  } else if (isPending) {
    return (
      <ReportContainer>
        <LoadingBar color={palette.textSecondary} />
      </ReportContainer>
    );
  }

  const noData =
    props.data &&
    !props.data.house?.length &&
    !props.data.population &&
    !props.data.officeWorker;

  if (noData) {
    return (
      <ReportContainer>
        <NoData text="분석 지역 내 생활 인구 정보가 없습니다." />
      </ReportContainer>
    );
  }

  return (
    <>
      <HouseMarkers map={map} items={props.data} />
      <ReportContainer>
        <ColumnFlexBox gap={40}>
          <Household {...props} />
          <ResidentPopulation {...props} />
          <OfficeWorker {...props} />
        </ColumnFlexBox>
      </ReportContainer>
    </>
  );
};
